// extracted by mini-css-extract-plugin
export default {"wrapper":"PieChartCustomTooltip_wrapper__jt6A-"};